import validate from "/var/lib/jenkins/workspace/paxgon/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.2_eslint@9.17.0_jiti@2.4.2__iore_5ao2akc3j7xer3w7deel4fa73e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/paxgon/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.2_eslint@9.17.0_jiti@2.4.2__iore_5ao2akc3j7xer3w7deel4fa73e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}